import React from 'react';
import { ListItem, ListItemContent, Box } from "@mui/joy";
import { Button } from '../Button';

import { useTranslation } from 'react-i18next'
import { LegalEntityAvatar, Tag, PersonAvatar } from '../Snippet';
import { useDrawer } from '../Drawer'


const RelationshipAudienceLead = ({ k, v, editing, detailInspector = true, handleItemDetail, handleItemRemove, loadingDissociation }) => {
    const { t, i18n } = useTranslation();

    const { activate } = useDrawer();
    return (

        <ListItem k={k} variant="outlined" className={"relationship-element"}>
            <ListItemContent className={"relationship-element-content"}>
                {
                    v.companyName && v.companyName.length > 0 && <LegalEntityAvatar name={v.companyName} withname={true} />
                }
                {
                    v.firstname && v.firstname.length > 0 && <PersonAvatar firstname={v?.firstname} lastname={v?.lastname} url={v?.picture?.url} withname={true} item={v}/>
                }
                
                <Box className="mobile coupled">
                    <Box className="label">{t('mobile')}</Box>
                    <Box className="value">
                        {v?.mobile ?? '-'}
                    </Box>
                </Box>
                <Box className="telephone coupled">
                    <Box className="label">{t('telephone')}</Box>
                    <Box className="value">
                        {v?.telephone ?? '-'}
                    </Box>
                </Box>
                <Box className="type coupled">
                    <Box className="label">{t('type')}</Box>
                    <Box className="value">
                        {t(v?.type) ?? '-'}
                    </Box>
                </Box>

            </ListItemContent>
            {editing && handleItemDetail && detailInspector && (<Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />)}
            {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />)}
        </ListItem>
    )
}

export default RelationshipAudienceLead



